import type { ReactNode } from "react";

// Chips de status usados nos cards de torneio do app original.
type Tone = "success" | "accent" | "muted" | "destructive";

const TONE_CLASSES: Record<Tone, string> = {
  success: "bg-success/20 text-tint",
  accent: "bg-accent/20 text-accent",
  muted: "bg-muted text-muted-foreground",
  destructive: "bg-destructive/20 text-[#ffb4ad]",
};

export function Chip({
  tone = "muted",
  children,
  className = "",
}: {
  tone?: Tone;
  children: ReactNode;
  className?: string;
}) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-[10px] font-bold tracking-wider ${TONE_CLASSES[tone]} ${className}`}
    >
      {children}
    </span>
  );
}
